// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { iPhoneResolution } from "Content/Shared/Styles/Theme"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  flag: any
  color: string

  title: string
  level: string
}

const LanguageItem: React.FC<PropsType> = (props) => {
  return (
    <Wrapper>
      <Image src={props.flag} />
      <div
        style={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Title>{props.title}</Title>
        <div style={{ color: props.color }}>{props.level}</div>
      </div>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  margin-right: 5%;
  margin-bottom: 20px;
`

const ICON_SIZE = "20px"
const Image = styled.img`
  width: ${ICON_SIZE};
  height: ${ICON_SIZE};
  margin-bottom: 7px;
`

const Title = styled.span`
  font-weight: 600;
  word-spacing: 2px;
  margin-bottom: 1.8px;

  span {
    font-weight: normal;
    font-size: 16px;
  }
`

export default React.memo(LanguageItem, memoComparison)
